import script from "./VTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VTable.vue?vue&type=script&setup=true&lang=js"

import "./VTable.vue?vue&type=style&index=0&id=3e1b291c&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1b291c"]])

export default __exports__